<template>
  <div class="mg-x-auto mg-y-5 signin-page">
  <div class="is-hidden-mobile">
    <div v-if="!forgetpass" >
    <span class="fontbold2">Sign in</span>   
    <div class="mg-t-15">
      <b-notification
            :class="{'shake animated': animated}"
            auto-close type="is-danger"
            duration="10000"
            :active.sync="loginError"
            :closable="false"
            >{{textError}}
      </b-notification>
    </div>
      <div>
        <b-field label="Email" style="margin-top:40px;">
          <b-input class="fontnormal" type="email" placeholder="Email" v-model="login.email"></b-input>
        </b-field>
        <b-field label="Password">
          <b-input class="fontnormal"  @keyup.native.enter="signin_c" type="password" placeholder="Password" v-model="login.password"></b-input>
        </b-field>
        <div class="field control" >
          <b-checkbox v-model="remember">remember me </b-checkbox> <span @click="forgetpass = !forgetpass" style="cursor:pointer" class="forgot">  Forgot password?</span> 
        </div>
        <br>
        <div class="buttons sign-in" style="margin-top:30px;">
          <a @click="signin_c()" class="button is-primary buttonc pd-20">
            <span class="fontbold">SIGN IN</span>
          </a>
        </div>
        <div class="or">
          <span>or</span>
          <hr/>
        </div>
        <div class="buttons sign-in">
          <!-- @click="gopath('/signupsuccess')" -->
                    <router-link to="/authorized" class="button is-primary buttonc inteGreat is-uppercase" style="display: table;">
            <span class="fontbold is-flex is-justify-center is-align-center">SIGN IN WITH <img src="@/assets/btn-integreat.png" class="mg-l-2"></span>
                    </router-link>
        </div>
        <div class="donthaveaccount">
          Don't have COMPANY account? <span @click="gopath('/signup/company')" >SIGN UP here!</span> 
        </div>
      </div>
    </div>
    <div v-if="forgetpass" >
      <span class="fontbold2">Forgot password</span>   
      <b-field label="Email" class="mg-t-40">
        <b-input class="fontnormal" type="email" placeholder="example@gmail.com" v-model="forgotemail"></b-input>
      </b-field>
      <div class="buttons ">
        <a @click="forgotemail_c()" class="button is-primary buttonc" >
          <span class="fontbold ">Forgot Password</span>
        </a>
      </div>
      <div @click="forgetpass = !forgetpass" class="has-text-centered mg-t-40 is-uppercase" style="color:#FD7900;cursor:pointer">
        Back to sign in
      </div>
    </div>
  </div>
  <div class="is-hidden-tablet">
    <div v-if="!forgetpass" class="columns">
      <div class="column is-12 has-text-centered	">
        <span class="fontbold2">Sign in</span>   
      </div>
    
    <div class="mg-t-15">
      <b-notification
            auto-close type="is-danger"
            duration="10000"
            :active.sync="loginError"
            :closable="false"
            >{{textError}}
      </b-notification>
    </div>
      <div class="mg-40">
        <b-field label="Email">
          <b-input class="fontnormal" type="email" placeholder="Email" v-model="login.email"></b-input>
        </b-field>
        <b-field label="Password">
          <b-input class="fontnormal"  @keyup.native.enter="signin_c" type="password" placeholder="Password" v-model="login.password"></b-input>
        </b-field>
        <div class="field control" >
          <b-checkbox v-model="remember">remember me </b-checkbox> <span @click="forgetpass = !forgetpass" style="cursor:pointer" class="forgot">  Forgot password?</span> 
        </div>
        <br>
        <div class="buttons sign-in" style="margin-top:30px;">
          <a @click="signin_c()" class="button is-primary buttonc pd-20">
            <span class="fontbold">SIGN IN</span>
          </a>
        </div>
        <div class="or">
          <span>or</span>
          <hr/>
        </div>
        <div class="buttons sign-in">
          <!-- @click="gopath('/signupsuccess')" -->
                    <router-link to="/authorized" class="button is-primary buttonc inteGreat is-uppercase" style="display: table;">
            <span class="fontbold is-flex is-justify-center is-align-center">SIGN IN WITH <img src="@/assets/btn-integreat.png" class="mg-l-2"></span>
                    </router-link>
        </div>
        <div class="donthaveaccount">
          Don't have COMPANY account? <span @click="gopath('/signup/company')" >SIGN UP here!</span> 
        </div>
      </div>
    </div>
    <div v-if="forgetpass"  class="mg-40">
      <span class="fontbold2">Forgot password</span>   
      <b-field label="Email" class="mg-t-40">
        <b-input class="fontnormal" type="email" placeholder="example@gmail.com" v-model="forgotemail"></b-input>
      </b-field>
      <div class="buttons ">
        <a @click="forgotemail_c()" class="button is-primary buttonc" >
          <span class="fontbold ">Forgot Password</span>
        </a>
      </div>
      <div @click="forgetpass = !forgetpass" class="has-text-centered mg-t-40 is-uppercase" style="color:#FD7900;cursor:pointer">
        Back to sign in
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import {HTTP,HTTPMentor} from "@/axios.js";
import navbarbg from './navbarbg'

export default {
        data() {
            return {
                login:{
                    email: '',
                    password:'',
                },
                remember:null,
                forgetpass:false,
                forgotemail:null,
                loginError:false,
                textError:'',
                animated: false,
            }
        },
        computed:{
          
        },
        methods:{
          signout(){
            setTimeout(() => {
              window.localStorage.clear();
            }, 100);
            this.$store.commit("clearlogin");
            window.localStorage.removeItem("vuex");
            this.$router.push("/signin");
        },
          gopath(val){
            this.$router.push(val)
          },
        forgotemail_c(){
          if(!this.forgotemail){
             this.$dialog.alert('<p class="has-text-centered is-size-5">Please type in all required fields</p>');
          }else{
            HTTPMentor.post(`send/email/forgot/pass`,{email : this.forgotemail})
            .then(res => {
              console.log('send/email/forgot/pass', res.data)
              if(res.data.success){
                this.forgotemail = ''
              
                this.$dialog.alert(`<p class="has-text-centered is-size-5"> ${res.data.message}</p>`);
               }else{
                this.forgotemail = ''
                this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
              }
            })
            .catch(e => {
              console.log("api/add/kpi/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
                 this.forgotemail = ''
            });
            }
        },
        signin_c(){
            // console.log(this.rememberlogin)
            // this.login = this.rememberlogin
            // return
           if(this.login.email && this.login.password){
            // HTTPMentor.defaults.headers.common.Authorization = `Bearer ${this.token}`;  
            HTTPMentor.post(`login`,this.login)
            .then(res => {
              console.log('signin', res.data)
              
              if(res.data.success){
                this.signup = {}
                console.log('res.data.obj',res.data.obj)
                 if(this.remember){
                    this.$store.commit('rememberlogin',this.login)
                 }else{
                    this.$store.commit('rememberlogin',{})
                 }
                 

                this.$store.commit('idlogin',res.data.obj.userId)
                //this.$dialog.alert('<p class="has-text-centered is-size-5">Login Successfully</p>');
                this.login = {}
                this.$store.commit('islogin',res.data.obj)
                let type = {
                    key:'typeSystem',
                    value:'mentor'
                  }
                  this.$store.commit('updateUser',type)
                  this.$router.push('/profile')
                if(res.data.obj.userLevel == 50){
                  this.$router.push('/form/edit')
                }else if(res.data.obj.userLevel == 0){
                  this.$router.push('/profile')
                }
                
               }else{
                this.loginError = true
                this.animated = true
                setTimeout(() => {
                  this.animated = false
                },1000)
                //this.textError = res.data.message
                this.textError = 'Invalid E-mail or password '
                //this.$dialog.alert(`<p class="has-text-centered is-size-5">${res.data.message}</p>`);
              }
            })
            .catch(e => {
              console.log("api/add/kpi/error",e);
                this.$dialog.alert('<p class="has-text-centered is-size-5">Please check your network connection</p>');
                 this.login = {}
            });
          }else{
            this.$dialog.alert('<p class="has-text-centered is-size-5">Please type in all required fields</p>');
          }  
        }
    },
    components:{
navbarbg
    },
    mounted() {

        this.signout()
    
      // console.log(this.rememberlogin.length)
            if(this.rememberlogin.email && this.rememberlogin.password){
            this.login = this.rememberlogin
            this.remember = true
            } 
        },
    computed: {
        rememberlogin(){
            return this.$store.state.rememberlogin
        },
        user(){
          return this.$store.state.islogin
        }
    },
}
</script>

<style scoped src="./formsign.css"></style>
<style lang="scss" scoped>
$blue : rgb(13, 106, 202);
$orange : #FFA800;
$orange-top : rgb(254,147,13);
$orange-bottom:  rgb(254,175,28);
$purple-top: rgb(139,98,228);
$purple-bottom: rgb(122,122,236);
.notification.is-danger{
    color: #ff3860;
    background-color: #f8d7da;
    
}


span.forgot{
  float: right;
}
span.forgot{
  color: $orange
}
.or{
  margin: 2rem 0;
  position: relative;
  span{
    position: absolute;
    text-align: center;
    color: rgba(0,0,0,0.2);
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    padding: 0 1rem;
    background: white;
  }
}

.buttonc{
  background-image:linear-gradient($orange-top, $orange-bottom);
}
.inteGreat{
  background-image: linear-gradient($purple-top, $purple-bottom);
}
.donthaveaccount{
  text-align: center;
  margin-top: 40px;
}
.donthaveaccount {
  span{
    color:#FD7900;cursor:pointer;font-weight:bold
  }
}
.sign-in{
  opacity: 0.6;
}
.sign-in:hover{
  opacity: 1;
}
.flex-center{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
div.control[data-v-02db7b30]{
  widows: 0;
}

</style>
